
import StudentListView from "@/views/students/StudentListView.vue";
import EditStudentView from "@/views/students/EditStudentView.vue";
import AddStudentView from "@/views/students/AddStudentView.vue";
import StudentDetails from "@/views/students/StudentDetails.vue";
import StudentGuardians from '@/views/studentGuardians/StudentGuardians.vue';

import StudentAttendance from "@/views/students/attendance/AttendanceIndex.vue";
import RecordAttendance from "@/views/students/attendance/RecordAttendance.vue";
import EditRecordAttendance from "@/views/students/attendance/EditAttendance.vue";
import StudentRewardHistory from '@/views/student-rewards/StudentRewardHistory.vue';

import StudentSchedule from '@/views/students/isStudent/StudentSchedule.vue';
import StudentSignedAttendance from '@/views/students/isStudent/StudentAttendance.vue';
import StudentAssignments from "@/views/students/isStudent/StudentAssignments.vue";
import StudentGrades from "@/views/students/isStudent/StudentGrades.vue";
import StudentAssignmentSubmit from "@/views/students/isStudent/StudentAssignmentSubmit.vue";
import StudentAcademicHistory from '@/views/students/StudentAcademicHistory.vue';
export default [
  {
    path: '/students',
    name: 'students.index',
    component: StudentListView,
    meta: { 
      title: 'students.indexTitle',
      requiresAuth: true,
      requiredPerm: 'students.display'
    },
    children: [
      {
        path: 'add',
        name: 'students.add',
        component: AddStudentView,
        meta: { 
          title: 'students.addTitle',
          requiresAuth: true,
          requiredPerm: 'students.create'
        }
      },
      {
          path: '/students/:studentId/reward-history',
          name: 'student.reward.history',
          component: StudentRewardHistory,
          props: true,
          meta: { 
            requiresAuth: true,
            title: 'student_rewards.breadcrumbs.history',
            requiredPerm: 'student_rewards.display',
          }
        },
      {
        path: ':id/edit',
        name: 'students.edit',
        component: EditStudentView,
        meta: { 
          title: 'students.editTitle',
          requiresAuth: true,
          requiredPerm: 'students.update'
        },
        props: true
      },
      {
        path: ':id',
        name: 'student-details',
        component: StudentDetails,
        meta: { 
          title: 'students.detailsTitle',
          requiresAuth: true,
          requiredPerm: 'students.display'
        }
      },
      {
        path: 'students/:id/guardians',
        name: 'students.guardians',
        component: StudentGuardians,
        meta: { 
          title: 'students.guardiansTitle',
          requiresAuth: true,
          requiredPerm: 'student_guardians.display'
        },
        props: true
      },
      {
  path: ':id/academic-history',
  name: 'students.academic-history',
  component: StudentAcademicHistory,
  meta: { 
    title: 'students.academicHistoryTitle',
    requiresAuth: true,
    requiredPerm: 'students.display'
  },
  props: true
}
    ]
  },

  {
    path: '/attendances',
    name: 'attendances',
    component: StudentAttendance,
    meta: { 
      title: 'attendance.indexTitle',
      requiresAuth: true,
      requiredPerm: 'student_attendance.display'
    },
    children: [
      {
        path: 'record',
        name: 'attendances.record',
        component: RecordAttendance,
        meta: { 
          title: 'attendance.recordTitle',
          requiresAuth: true,
          requiredPerm: 'student_attendance.create'
        }
      },
      {
        path: 'edit/:id',
        name: 'attendances.edit',
        component: EditRecordAttendance,
        meta: { 
          title: 'attendance.editTitle',
          requiresAuth: true,
          requiredPerm: 'student_attendance.update'
        },
        props: true
      }
    ]
  },

  {
    path: '/student-schedule',
    name: 'student.schedule',
    component: StudentSchedule,
    meta: { 
      title: 'students.scheduleTitle',
      requiresAuth: true,
      requiredPerm: 'student_schedule.display'
    }
  },
  {
    path: '/student-assignments',
    name: 'student.assignments',
    component: StudentAssignments,
    meta: { 
      title: 'students.assignmentsTitle',
      requiresAuth: true,
      requiredPerm: 'student_assignments.display'
    }
  },
  {
    path: '/student-assignments/:assignmentId/submit',
    name: 'student.assignments.submit',
    component: StudentAssignmentSubmit,
    meta: { 
      title: 'students.assignmentSubmitTitle',
      requiresAuth: true,
      requiredPerm: 'student_assignments.submit'
    },
    props: true
  },
  {
    path: '/student-attendances',
    name: 'student.attendances',
    component: StudentSignedAttendance,
    meta: { 
      title: 'students.signedAttendancesTitle',
      requiresAuth: true,
      requiredPerm: 'student_attendance_signed.display'
    }
  },
  {
    path: '/student-grades',
    name: 'student.grades',
    component: StudentGrades,
    meta: { 
      title: 'students.gradesTitle',
      requiresAuth: true,
      requiredPerm: 'student_grades.display'
    }
  }
];
